import React from "react";
import styled from "styled-components";


export default styled.div`
    text-align: right;
    padding-right: 20px;
    @media(max-width: 725px) {
        text-align: left;
    }
`;